

function showPropertyCard() {

    let windowHandle = null;
    let download = false;

    if (getUserAgent() === 'SafariMobile') {
        download = true;
    }

    if (!download) {

        windowHandle =
            window.open(
                '',
                '_blank'
            );

        if (!windowHandle) {
            alert('Please allow popups to view the Property Record Card.');
            return;
        }

        windowHandle.document.write(`
            <?php /* Template Name: PaoSkeletonPrc */ ?>
            <?php
            ?>

            <style>
            /* latin-ext */
            @font-face {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 700;
            font-display: swap;
            src: url(/wp-content/themes/frontier-child/fonts/S6u9w4BMUTPHh6UVSwaPGR_p.woff2) format('woff2');
            unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }

            /* latin */
            @font-face {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 700;
            font-display: swap;
            src: url(/wp-content/themes/frontier-child/fonts/S6u9w4BMUTPHh6UVSwiPGQ.woff2) format('woff2');
            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            body {
                font-family: 'Lato', sans-serif;
                color: rgba(0, 0, 0, 0.66);
            }

            @keyframes blink {
                0% { opacity: .2; }
                20% { opacity: 1; }
                100% { opacity: .2; }
            }

            .loading span {
                animation-name: blink;
                animation-duration: 1.4s;
                animation-iteration-count: infinite;
                animation-fill-mode: both;
                position: relative;
                font-size: 1.8em;
            }

            .loading span:nth-child(2) {
                animation-delay: .2s;
            }

            .loading span:nth-child(3) {
                animation-delay: .4s;
            }

            .loading-text {
                height: 15em;
                display: -webkit-box;
                display: -moz-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
            }

            .loading-text p {
                text-align: center;
                font-size: 1.9rem;
            }
            </style>

            <div class="container">
                <div class="loading-text">
                    <p class="loading">
                        Please wait. Your Property Record Card will be displayed shortly
                        <span>.</span><span>.</span><span>.</span>
                    </p>
                </div>
            </div>
        `);

        windowHandle.document.close();
    }

    const payload = {
        parid: paoDetails.context.parid,
        isTppParcel: paoDetails.context.isTppParcel,
        isLeasingCompany: paoDetails.context.isLeasingCompany,
        source_url: window.location.origin
    };

    const data = JSON.stringify(payload);

    requestAnimationFrame(() => {

        setTimeout(() => {

            $.ajax({
                url: paoDetails.context.child_uri + '/models/pao-pdfw.php',
                type: 'POST',
                data: {
                    params: data,
                    report: 'prc'
                },
                dataType: 'text'
            })
            .fail(function (jqXHR, textStatus, errorThrown) {

                const err =
                    textStatus + ', ' + errorThrown;

                consoleErrorIfTestMode(
                    `Request Failed: ${err}`
                );
            })
            .done(function (result) {

                if (result && result.length) {

                    if (download) {

                        window.history.pushState(
                            '',
                            '',
                            '/parcel/?parid=' + paoDetails.context.parid
                        );

                        window.location.href =
                            paoDetails.context.href +
                            '/prc?download=1';

                    } else {

                        windowHandle.location.href =
                            paoDetails.context.href +
                            '/prc';
                    }
                }
            });

        }, 50);
    });
}